import { 
  HeroContainer, 
  InnerWrapper,
  TextContent,
  Label,
  MainTitle,
  Description,
  VisualMural,
  PillarCard,
  PillarIcon,
  PillarTitle,
  PillarText,
  CTAWrapper,
  PrimaryButton,
  SecondaryButton
} from './HeroStyle';
import { Bio } from '../../data/constants';
import { motion } from 'framer-motion';
import { Compass, Zap, Target, BarChart3 } from 'lucide-react';

const SignatureHero = () => {
  const pillars = [
    {
      Icon: Compass,
      title: "Strategic Discovery",
      desc: "Uncovering deep user insights and market opportunities to define 'what' we build and 'why'.",
      delay: "0s"
    },
    {
      Icon: Zap,
      title: "Rapid Definition",
      desc: "Translating complex problems into clear product requirements and high-fidelity roadmaps.",
      delay: "0.2s"
    },
    {
      Icon: Target,
      title: "Precision Craft",
      desc: "Bridging engineering precision with human-centric design to ship world-class experiences.",
      delay: "0.4s"
    },
    {
      Icon: BarChart3,
      title: "Measurable Impact",
      desc: "Iterating based on technical metrics and user feedback to maximize growth and NPS.",
      delay: "0.6s"
    }
  ];

  return (
    <HeroContainer>
      <InnerWrapper>
        <TextContent
          as={motion.div}
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <Label>My Core Philosophy</Label>
          <MainTitle>
            Code that feels <span>designed</span>. Engineering that is clear.
          </MainTitle>
          <Description>
            Strategic Associate Product Manager transforming technical complexity into simple, scalable, user-centric products (0→1→N).
          </Description>
          <CTAWrapper>
            <PrimaryButton href="#projects">Explore Process</PrimaryButton>
            <SecondaryButton href={Bio.resume} target="_blank">View Dossier</SecondaryButton>
          </CTAWrapper>
        </TextContent>

        <VisualMural
          as={motion.div}
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
        >
          {pillars.map((pillar, i) => {
            const Icon = pillar.Icon;
            return (
              <PillarCard key={i} delay={pillar.delay}>
                <PillarIcon>
                  <Icon size={22} />
                </PillarIcon>
                <PillarTitle>{pillar.title}</PillarTitle>
                <PillarText>{pillar.desc}</PillarText>
              </PillarCard>
            );
          })}
        </VisualMural>
      </InnerWrapper>
    </HeroContainer>
  );
};

export default SignatureHero;
